<template>
  <div>
    <ul v-if="existError">
      <p class="form-error-tips">入力内容に誤りがあります</p>
    </ul>
    <form class="form" id="entry" :action="endpoint" method="post" @submit.prevent="submitCheck">
      <input type="hidden" :name="csrf.param" :value="csrf.token">

      <VeeForm ref="step1" as="div">
        <div v-show="step === 1">
          <div v-if="isPriorityAgent">
            <section class="appointment-form" v-if="shop_reservation_data">
              <div class="agent-list-item">
                <div class="agent">
                  <div class="agent-name">{{ shop_reservation_data.agent.name }}</div>
                  <img :src="shop_reservation_data.agent.logo_url" :alt="shop_reservation_data.agent.name" class="agent-image" v-if="shop_reservation_data.agent.logo_url">
                  <div class="agent-summary">{{ shop_reservation_data.agent.summary }}</div>
                </div>
              </div>
            </section>
          </div>
          <div class="select-program">
            <p v-if="isPriorityAgent" class="header">選択したプログラムについて無料で相談する｜パンフレットもお届けします</p>
            <p v-else class="header">選択したプログラムを含む留学パンフレットをお届けします</p>
            <p class="program-name">{{ program.name }}</p>
            <p class="agent-name">{{ program.agent_name }}</p>
            <input type="hidden" name="program_cv[program_id]" :value="program.id">
          </div>

          <fieldset class="fieldset">
            <legend class="legend required">お名前</legend>
            <div class="twin">
              <div class="twin-item">
                <Field v-slot="{ errors }" v-model="familyName" rules="required" name="名字">
                  <label for="applicant[family_name]" class="label">姓</label>
                  <input id="applicant[family_name]" v-model="familyName" type="text" name="applicant[family_name]" placeholder="鈴木" class="input-field" @input="inputFurigana1()">
                  <div class="form-error">
                    <span class="form-error-item">{{ errors[0] }}</span>
                  </div>
                </Field>
              </div>
              <div class="twin-item">
                <Field v-slot="{ errors }" v-model="givenName" rules="required" name="名前">
                  <label for="applicant[given_name]" class="label">名</label>
                  <input id="applicant[given_name]" v-model="givenName" type="text" name="applicant[given_name]" placeholder="花子" class="input-field" @input="inputFurigana2()">
                  <div class="form-error">
                    <span class="form-error-item">{{ errors[0] }}</span>
                  </div>
                </Field>
              </div>
            </div>
          </fieldset>

          <fieldset class="fieldset">
            <legend class="legend required">フリガナ</legend>
            <div class="twin">
              <div class="twin-item">
                <Field v-slot="{ errors }" v-model="familyNameKana" rules="required|name" name="名字のフリガナ">
                  <label for="applicant[family_name_kana]" class="label">セイ</label>
                  <input id="applicant[family_name_kana]" v-model="familyNameKana" type="text" name="applicant[family_name_kana]" placeholder="スズキ" class="input-field">
                  <div class="form-error">
                    <span class="form-error-item">{{ errors[0] }}</span>
                  </div>
                </Field>
              </div>
              <div class="twin-item">
                <Field v-slot="{ errors }" v-model="givenNameKana" rules="required|name" name="名前のフリガナ">
                  <label for="applicant[given_name_kana]" class="label">メイ</label>
                  <input id="applicant[given_name_kana]" v-model="givenNameKana" type="text" name="applicant[given_name_kana]" placeholder="ハナコ" class="input-field">
                  <div class="form-error">
                    <span class="form-error-item">{{ errors[0] }}</span>
                  </div>
                </Field>
              </div>
            </div>
          </fieldset>

          <button class="next step1" @click.prevent="next('step1')">次へ進む(1/{{ isPriorityAgent ? '4' : '5' }})</button>

        </div>
      </VeeForm>

      <VeeForm ref="step2" as="div">
        <div v-show="step === 2" class="no-program">
          <fieldset class="fieldset">
            <legend class="legend required">職業</legend>
            <Field v-slot="{ errors }" v-model="applicant.form_age_id" rules="required" name="職業">
              <div class="select-wrap">
                <select id="applicant[form_age_id]" v-model="applicant.form_age_id" class="select" name="applicant[form_age_id]">
                  <option value="">選択してください</option>
                  <option v-for="item in form_ages" :key="item.id" :value="item.id">{{ item.label }}</option>
                </select>
              </div>
              <div class="form-error">
                <span class="form-error-item">{{ errors[0] }}</span>
              </div>
            </Field>
          </fieldset>

          <fieldset class="fieldset">
            <legend class="legend required">年齢</legend>
            <Field v-slot="{ errors }" v-model="applicant.age" rules="required|numeric|between:4,120" name="年齢">
              <input id="applicant[age]" v-model="applicant.age" type="tel" name="applicant[age]" placeholder="24" class="input-field">
              <div class="form-error">
                <span class="form-error-item">{{ errors[0] }}</span>
              </div>
            </Field>
          </fieldset>

          <button class="next step2" @click.prevent="next('step2')">次へ進む(2/{{ isPriorityAgent ? '4' : '5' }})</button>
        </div>
      </VeeForm>

      <VeeForm ref="step3" as="div">
        <div v-show="step === 3" class="no-program">
          <p class="guide">
            留学検討のご状況について選択してください
          </p>
          <fieldset class="fieldset">
            <legend class="legend required">留学予算</legend>
            <Field v-slot="{ errors }" v-model="applicant.budget" rules="required" name="留学予算">
              <div class="select-wrap">
                <select id="applicant[budget]" v-model="applicant.budget" class="select" name="applicant[budget]">
                  <option value="">選択してください</option>
                  <option v-for="item in budgets" :key="item.value" :value="item.value">{{ item.label }}</option>
                </select>
              </div>
              <div class="form-error">
                <span class="form-error-item">{{ errors[0] }}</span>
              </div>
            </Field>
          </fieldset>

          <fieldset class="fieldset">
            <legend class="legend required">留学予定時期</legend>
            <Field v-slot="{ errors }" v-model="applicant.prearranged_date" rules="required" name="留学予定時期">
              <div class="select-wrap">
                <select id="applicant[prearranged_date]" v-model="applicant.prearranged_date" class="select" name="applicant[prearranged_date]">
                  <option value="">選択してください</option>
                  <option v-for="item in prearranged_dates" :key="item.value" :value="item.value">{{ item.label }}</option>
                </select>
              </div>
              <div class="form-error">
                <span class="form-error-item">{{ errors[0] }}</span>
              </div>
            </Field>
          </fieldset>

          <fieldset class="fieldset">
            <legend class="legend required">留学予定期間</legend>
            <Field v-slot="{ errors }" v-model="applicant.period" rules="required" name="留学予定期間">
              <div class="select-wrap">
                <select id="applicant[period]" v-model="applicant.period" class="select" name="applicant[period]">
                  <option value="">選択してください</option>
                  <option v-for="item in periods" :key="item.value" :value="item.value">{{ item.label }}</option>
                </select>
              </div>
              <div class="form-error">
                <span class="form-error-item">{{ errors[0] }}</span>
              </div>
            </Field>
          </fieldset>

          <fieldset class="fieldset" v-if="isPriorityAgent">
            <legend class="legend required">都道府県</legend>
            <Field v-slot="{ errors }" v-model="applicant.prefecture_id" rules="required" name="都道府県">
              <div class="select-wrap">
                <select id="prefecture-id" ref="prefectureId" v-model="applicant.prefecture_id" class="select" name="applicant[prefecture_id]">
                  <option value="">選択してください</option>
                  <option v-for="item in prefectures" :key="item.id" :value="item.id">{{ item.name }}</option>
                </select>
              </div>
              <div class="form-error">
                <span class="form-error-item">{{ errors[0] }}</span>
              </div>
            </Field>
          </fieldset>

          <fieldset class="fieldset" v-if="!isPriorityAgent">
            <legend class="legend elective">その他ご要望</legend>
            <textarea class="textarea" name="applicant[message]"></textarea>
          </fieldset>

          <fieldset class="recommend" v-if="!isPriorityAgent && recommend_programs.length > 0">
            <legend class="recommend-legend">
              <span class="program-age-name">{{ age_name }}</span>におすすめパンフもまとめてもらう</legend>
            <div v-for="(program, key) in recommend_programs" :key="key">
              <recommend-program :program="program" input-name="recommend_program_cvs[program_ids][]"></recommend-program>
            </div>
          </fieldset>

          <button class="next step3" @click.prevent="next('step3')">次へ進む({{ isPriorityAgent ? '3/4' : '3/5' }})</button>
        </div>
      </VeeForm>

      <VeeForm ref="step4" as="div">
        <div v-show="step === 4" class="no-program">
          <div v-if="!isPriorityAgent">
            <p class="guide">
              パンフレットのお届け先を入力ください<br>
              <span class="guide-small">※ 入力頂いた情報はSSLにより暗号化して送信されるので安全です。</span>
            </p>

            <fieldset class="fieldset">
              <legend class="legend required">郵便番号</legend>
              <Field v-slot="{ errors }" v-model="applicant.zip_address" rules="required|numeric|digits:7" name="郵便番号">
                <input id="zip-address" v-model="applicant.zip_address" type="tel" name="applicant[zip_address]" placeholder="1050001" class="input-field">
                <div class="form-error">
                  <span class="form-error-item">{{ errors[0] }}</span>
                </div>
              </Field>
            </fieldset>

            <fieldset class="fieldset">
              <legend class="legend required">都道府県</legend>
              <div class="select-wrap">
                <select id="prefecture-id" ref="prefectureId" class="select" name="applicant[prefecture_id]">
                  <option value="">選択してください</option>
                  <option v-for="item in prefectures" :key="item.id" :value="item.id">{{ item.name }}</option>
                </select>
              </div>
              <div class="form-error">
                <span class="form-error-item">{{ errorPrefectureId }}</span>
              </div>
            </fieldset>

            <fieldset class="fieldset">
              <legend class="legend required">市区町村</legend>
              <input id="city" ref="city" type="text" name="applicant[city]" placeholder="港区虎ノ門" class="input-field">
              <div class="form-error">
                <span class="form-error-item">{{ errorCity }}</span>
              </div>
            </fieldset>

            <fieldset class="fieldset">
              <legend class="legend required">番地</legend>
              <Field v-slot="{ errors }" v-model="applicant.lot_number" rules="required" name="番地">
                <input id="applicant[lot_number]" v-model="applicant.lot_number" type="text" name="applicant[lot_number]" placeholder="3-4-8" class="input-field">
                <div class="form-error">
                  <span class="form-error-item">{{ errors[0] }}</span>
                </div>
              </Field>
            </fieldset>

            <single-input-field input-name="applicant[building]" input-type="text" placeholder="留学マンション 102号室" :required="false">
              <template #legend>建物名など</template>
            </single-input-field>
          </div>

          <div v-if="isPriorityAgent">
            <fieldset class="fieldset">
              <legend class="legend required">電話番号</legend>
              <Field v-slot="{ errors }" v-model="applicant.phone_number" rules="required|numeric|min:10|max:14" name="電話番号">
                <input id="applicant[phone_number]" v-model="applicant.phone_number" type="tel" name="applicant[phone_number]" placeholder="0300001111" class="input-field">
                <div class="form-error">
                  <span class="form-error-item">{{ errors[0] }}</span>
                </div>
              </Field>
            </fieldset>

            <fieldset class="fieldset">
              <legend class="legend required">メールアドレス</legend>
              <Field v-slot="{ errors }" v-model="emailValue" rules="required|email" name="メールアドレス">
                <input list="complemented-emails" class="input-field" inputType="text" name="applicant[email]" placeholder="info.ryugaku@kuraveil.jp" v-model="emailValue">
                <datalist id="complemented-emails">
                  <option :value="complementedEmail(domain)" v-for="domain in emailDomains" :key="domain" />
                </datalist>
                <div class="form-error">
                  <span class="form-error-item">{{ errors[0] }}</span>
                </div>
              </Field>
            </fieldset>

            <fieldset class="fieldset">
              <legend class="legend required">相談したい日時を教えてください</legend>
              <p class="form-hint">※本日から2日後以降／11:00～19:00の間でご入力ください</p>
              <Field v-slot="{ errors }" v-model="applicant.message" rules="required" name="相談したい日時" as="div">
                <textarea class="textarea" name="applicant[message]" v-model="applicant.message" placeholder="例　4/2 18:00"></textarea>
                <div class="form-error">
                  <span class="form-error-item">{{ errors[0] }}</span>
                </div>
              </Field>
            </fieldset>

            <div class="agreement">
              <p class="links">
                <a class="link" href="/privacy_policy" rel="noopener" target="_blank">プライバシーポリシー</a>
                、
                <a class="link" href="/rules" rel="noopener" target="_blank">利用規約</a>
                に
              </p>
              <label class="label">
                <input class="checkbox" name="applicant[agreement]" type="checkbox" checked="checked" value="1">
                <span class="pseudo-checkbox">同意する</span>
              </label>
              <p class="announce">ご登録頂いた個人情報は上記の企業（その提携先等）に提供されます。</p>
            </div>
          </div>

          <button class="next step4" @click.prevent="nextToStep5" v-if="!isPriorityAgent">次へ進む(4/5)</button>
          <button class="next step4" type="button" :disabled="isDisable" v-if="isPriorityAgent" @click="submitPriorityAgent">
            <span v-if="isSubmitting" class="btn-spinner"></span>{{ isSubmitting ? '送信中...' : 'この内容で送信' }}
          </button>
        </div>
      </VeeForm>

      <VeeForm ref="step5" as="div">
        <div v-show="step === 5 && !isPriorityAgent" class="no-program">
          <fieldset class="fieldset">
            <legend class="legend required">電話番号</legend>
            <Field v-slot="{ errors }" v-model="applicant.phone_number" rules="required|numeric|min:10|max:14" name="電話番号">
              <input id="applicant[phone_number]" v-model="applicant.phone_number" type="tel" name="applicant[phone_number]" placeholder="0300001111" class="input-field">
              <div class="form-error">
                <span class="form-error-item">{{ errors[0] }}</span>
              </div>
            </Field>
          </fieldset>

          <fieldset class="fieldset">
            <legend class="legend required">メールアドレス</legend>
            <Field v-slot="{ errors }" v-model="emailValue" rules="required|email" name="メールアドレス">
              <input list="complemented-emails" class="input-field" inputType="text" name="applicant[email]" placeholder="info.ryugaku@kuraveil.jp" v-model="emailValue">
              <datalist id="complemented-emails">
                <option :value="complementedEmail(domain)" v-for="domain in emailDomains" :key="domain" />
              </datalist>
              <div class="form-error">
                <span class="form-error-item">{{ errors[0] }}</span>
              </div>
            </Field>
          </fieldset>

        <div class="agreement">
          <p class="links">
            <a class="link" href="/privacy_policy" rel="noopener" target="_blank">プライバシーポリシー</a>
            、
            <a class="link" href="/rules" rel="noopener" target="_blank">利用規約</a>
            に
          </p>
          <label class="label">
            <input class="checkbox" name="applicant[agreement]" type="checkbox" checked="checked" value="1">
            <span class="pseudo-checkbox">同意する</span>
          </label>
          <p class="announce">ご登録頂いた個人情報は上記の企業（その提携先等）に提供されます。</p>
        </div>

          <button class="next step5" type="submit" :disabled="isDisable">
            <span v-if="isSubmitting" class="btn-spinner"></span>{{ isSubmitting ? '送信中...' : 'この内容で送信' }}
          </button>
        </div>
      </VeeForm>

    </form>
  </div>
</template>

<script>
import axios from 'axios'
import SingleInputField from '@/form/input-field/single'
import { convertFormDataForPost, pageBackToTop, pageToTop } from '@/form/modules/form'
import RecommendProgram from '@/form/recommend_program'
import { arrayAllTypeOf } from '@/form/validator'
import * as AutoKana from 'vanilla-autokana'
import { Form as VeeForm, Field, defineRule } from 'vee-validate'
import { setupZipSearch } from '@/utils/zip_search'
let autokana1
let autokana2

defineRule('required', (value, params, ctx) => {
  if (value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0)) {
    return `${ctx.field}を入力してください`
  }
  return true
})

defineRule('name', (value, params, ctx) => {
  if (!value || !value.match(/^[ア-ン゛゜ァ-ォャ-ョー「」、]+$/)) {
    return `${ctx.field}は全角カタカナで入力してください`
  }
  return true
})

defineRule('numeric', (value, params, ctx) => {
  if (!String(value).match(/^[0-9]*$/)) {
    return `${ctx.field}は数値で入力してください`
  }
  return true
})

defineRule('between', (value, [min, max], ctx) => {
  const num = Number(value)
  if (isNaN(num) || num < Number(min) || num > Number(max)) {
    return `${ctx.field}は${min}以上${max}以下で入力してください`
  }
  return true
})

defineRule('digits', (value, [length], ctx) => {
  if (!String(value).match(new RegExp(`^[0-9]{${length}}$`))) {
    return `${ctx.field}は${length}文字で入力してください`
  }
  return true
})

defineRule('email', (value, params, ctx) => {
  if (!value || !String(value).match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/)) {
    return `${ctx.field}正しい形式で入力してください`
  }
  return true
})

defineRule('min', (value, [length], ctx) => {
  if (!value || String(value).length < Number(length)) {
    return `${ctx.field}は${length}文字以上で入力してください`
  }
  return true
})

defineRule('max', (value, [length], ctx) => {
  if (value && String(value).length > Number(length)) {
    return `${ctx.field}は${length}文字以内で入力してください`
  }
  return true
})


export default {
  components: {
    SingleInputField,
    RecommendProgram,
    VeeForm,
    Field
  },

  props: {
    endpoint: {
      type: String,
      required: true
    },

    program: {
      type: Object,
      required: true,
      validator: function (program) {
        const requireKeys = [
          'id',         // program.id
          'name',       // program.name
          'agent_name'  // program.agent.name
        ]

        const filteredKeys = requireKeys.filter((key) => {
          return key in program
        })

        if (filteredKeys < requireKeys) {
          return false
        } else {
          return true
        }
      }
    },

    age_name: {
      type: String,
      required: true
    },

    form_ages: {
      type: Array,
      required: true,
      validator: function (ages) {
        return arrayAllTypeOf(ages, 'object')
      }
    },
    prefectures: {
      type: Array,
      required: true,
      validator: function (values) {
        return arrayAllTypeOf(values, 'object')
      }
    },

    budgets: {
      type: Array,
      required: true,
      validator: function (values) {
        return arrayAllTypeOf(values, 'object')
      }
    },
    prearranged_dates: {
      type: Array,
      required: true,
      validator: function (values) {
        return arrayAllTypeOf(values, 'object')
      }
    },
    periods: {
      type: Array,
      required: true,
      validator: function (values) {
        return arrayAllTypeOf(values, 'object')
      }
    },
    initialStep: {
      type: Number,
      default: 1
    },
    isPriorityAgent: {
      type: Boolean,
      default: false
    },
    shop_reservation_data: {
      type: Object,
      default: null
    }
  },

  data: function () {
    return {
      emailValue: '',
      csrf: {
        param: '',
        token: ''
      },
      familyName: '',
      givenName: '',
      familyNameKana: '',
      givenNameKana: '',
      applicant: {
        zip_address: '',
        lot_number: '',
        phone_number: '',
        budget: '',
        prearranged_date: '',
        period: '',
        form_age_id: '',
        prefecture_id: '',
        shop_reservation_desired_date: '',
        shop_reservation_desired_time: '',
        message: ''
      },
      selected: this.value || '',
      recommend_programs: [],
      errorPrefectureId: '',
      errorCity: '',
      existError: false,
      errors: [],
      isDisable: false,
      isSubmitting: false,
      emailDomains: [
        '@au.com',
        '@docomo.ne.jp',
        '@ezweb.ne.jp',
        '@gmail.com',
        '@hotmail.co.jp',
        '@hotmail.com',
        '@i.softbank.jp',
        '@icloud.com',
        '@me.com',
        '@mineo.jp',
        '@nifty.com',
        '@outlook.com',
        '@outlook.jp',
        '@softbank.ne.jp',
        '@yahoo.co.jp',
        '@yahoo.ne.jp',
        '@ymobile.ne.jp'
      ],
      step: this.initialStep
    }
  },

  computed: {
    existsOneAtmark () {
      return (this.emailValue.match(/@/g) || []).length === 1
    },
    emailUserName () {
      return this.emailValue.split('@')[0]
    },
    emailDomain () {
      return '@' + this.emailValue.split('@')[1]
    }
  },

  watch: {
    step (newVal) {
      this.updateStepBar(newVal - 1)
    }
  },

  mounted: function () {
    this.setCsrf()
    this.loadJpostal()
    this.setRecommendPrograms()
    this.updateStepBar(this.step - 1)

    autokana1 = AutoKana.bind('#applicant[family_name]', '#applicant[family_name_kana]', { katakana: true })
    autokana2 = AutoKana.bind('#applicant[given_name]', '#applicant[given_name_kana]', { katakana: true })

    // Enterキーの誤動作防止
    document.getElementById('entry').onkeydown = function (e) {
      if (e.key === 'Enter') { return false }
    }

    window.addEventListener('pageshow', this.resetSubmittingOnPageShow)
  },

  beforeUnmount: function () {
    window.removeEventListener('pageshow', this.resetSubmittingOnPageShow)
  },

  methods: {
    resetSubmittingOnPageShow: function (event) {
      if (event.persisted) { this.isSubmitting = false }
    },
    inputFurigana1 () {
      this.familyNameKana = autokana1.getFurigana()
    },
    inputFurigana2 () {
      this.givenNameKana = autokana2.getFurigana()
    },
    complementedEmail: function (domain) {
      // ドメインが完成している場合はサジェストしない
      if (this.emailDomain === domain) { return null }

      // @ が一つだけ存在する場合はサジェストする
      if (this.existsOneAtmark) { return this.emailUserName + domain }

      return null
    },
    setCsrf: function () {
      this.csrf.param = document.querySelector('meta[name="csrf-param"]')
        .getAttribute('content')
      this.csrf.token = document.querySelector('meta[name="csrf-token"]')
        .getAttribute('content')
    },
    submitCheck: function (e) {
      const applicantCheckbox = document.querySelector('input[name="applicant[agreement]"]')
      if (!applicantCheckbox.checked) {
        alert('プライバシーポリシー、利用規約の同意へのチェックをして下さい')
        this.isDisable = false
        this.isSubmitting = false
        return
      }
      const object = convertFormDataForPost(e)
      axios.post(this.endpoint, object).then((res) => {
        if (res.data.errors) {
          this.errors = res.data.errors
          pageToTop()
          this.isDisable = false
          this.isSubmitting = false
          this.existError = true
        } else {
          location.href = res.data.redirect_to
        }
      })
      this.isDisable = true
      this.isSubmitting = true
    },
    setRecommendPrograms: function (event) {
      const params = {
        'program_id': this.program.id
      }
      axios.get('/reserve/programs/recommend_programs', { params })
        .then((res) => { this.recommend_programs = res.data })
    },
    loadJpostal: function () {
      setupZipSearch({ zipInputId: 'zip-address', prefectureSelectId: 'prefecture-id', cityInputId: 'city' })
    },
    next: function (s) {
      this.$refs[s].validate().then(({ valid }) => {
        if (!valid) {
          this.existError = true
          pageToTop()
        } else {
          if (s === 'step3' && this.isPriorityAgent && !this.$refs.prefectureId.value) {
            this.errorPrefectureId = '都道府県を選択してください'
            this.existError = true
            pageToTop()
            return
          }

          this.existError = false

          if (s === 'step3' && this.isPriorityAgent) {
            this.step = 4
          } else {
            this.step++
          }

          pageBackToTop()
        }
      })
    },
    nextToStep5: function () {
      this.$refs.step4.validate().then(({ valid }) => {
        if (!valid) {
          this.existError = true
          pageToTop()
        } else {
          if (!this.$refs.prefectureId.value && this.$refs.city.value) {
            this.errorPrefectureId = '都道府県を入力してください'
            this.errorCity = ''
          } else if (!this.$refs.city.value && this.$refs.prefectureId.value) {
            this.errorCity = '市区町村を入力してください'
            this.errorPrefectureId = ''
          } else if (!this.$refs.prefectureId.value && !this.$refs.city.value) {
            this.errorPrefectureId = '都道府県を入力してください'
            this.errorCity = '市区町村を入力してください'
          } else {
            this.existError = false
            this.step++
            pageBackToTop()
          }
        }
      })
    },
    updateStepBar (currentIndex) {
      const steps = document.querySelectorAll('.step-bar-item')

      const maxSteps = this.isPriorityAgent ? 4 : 5

      steps.forEach((stepElement, index) => {
        stepElement.classList.remove('current')

        if (this.isPriorityAgent && index >= 4) {
          stepElement.style.display = 'none'
        } else {
          stepElement.style.display = ''
        }

        if (index <= currentIndex && index < maxSteps) {
          stepElement.classList.add('current')
        }
      })

      const currentStepElement = document.getElementById(`step-item-${currentIndex}`)
      if (currentStepElement) {
        currentStepElement.classList.add('current')
      }
    },
    submitPriorityAgent: function () {
      this.$refs.step4.validate().then(({ valid }) => {
        if (!valid) {
          this.existError = true
          pageToTop()
        } else {
          this.existError = false
          const form = document.getElementById('entry')
          this.submitCheck({ target: form })
        }
      })
    }
  }
}
</script>
